import React from 'react'
import ReactDOM from 'react-dom/client'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { SnackbarProvider } from 'notistack'

import App from './App'
import InstallPrompt from './components/common/InstallPrompt'
import reportWebVitals from './reportWebVitals'
import theme from '../src/theme'
import { UserProvider } from './contexts/UserContext'
import 'react-photo-view/dist/react-photo-view.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnWindowFocus: false,
    },
  },
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <UserProvider>
            <App />
          </UserProvider>
        </SnackbarProvider>
      </QueryClientProvider>
      <InstallPrompt />
    </ThemeProvider>
  </React.StrictMode>
)

// SW registration with onUpdate callback is handled in App.tsx
// to properly show the "New content available" update prompt.

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
